@if (property) {

<!-- ═══════════════════════════════════════════
     UNITS CARD
═══════════════════════════════════════════ -->
<div (click)="onClick()"
  class="group relative flex h-full cursor-pointer flex-col overflow-hidden rounded-[20px] border border-white/10 bg-white/5 border-t-white/20 border-l-white/20 shadow-[0_10px_30px_-5px_rgba(0,0,0,0.8),inset_0_2px_4px_rgba(255,255,255,0.1)] backdrop-blur-xl transition-all duration-300 ease-out hover:-translate-y-1 hover:border-primary/60 hover:bg-black/20 hover:shadow-[0_20px_40px_-10px_rgba(0,0,0,0.9),inset_0_2px_4px_rgba(255,255,255,0.2),0_0_15px_rgba(228,87,5,0.2)]">

  <!-- Radial glow on hover (pseudo-element via ring trick) -->
  <div
    class="pointer-events-none absolute inset-0 z-0 rounded-[20px] bg-[radial-gradient(700px_220px_at_50%_0%,rgba(222,88,6,0.12),transparent_65%)] opacity-0 transition-opacity duration-300 group-hover:opacity-100">
  </div>

  <!-- ══════════════ IMAGE ══════════════ -->
  <div class="relative h-[220px] w-full flex-shrink-0 overflow-hidden bg-black/40">

    <img [src]="image" [alt]="title"
      class="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />

    <!-- Gradient overlay -->
    <div
      class="pointer-events-none absolute inset-0 z-[1] bg-[linear-gradient(to_top,rgba(0,0,0,0.32)_0%,transparent_50%,rgba(0,0,0,0.08)_100%)]">
    </div>

    <!-- ── Badges: top-start ── -->
    <div class="absolute start-3 top-3 z-10 flex max-w-[62%] flex-col gap-1.5">

      @if (isFeatured) {
      <span
        class="inline-flex w-fit items-center gap-1 rounded-lg bg-gradient-to-br from-[#de5806] to-[#470e03] px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-wider text-white backdrop-blur-sm">
        <i class="fa-solid fa-star text-[9px]"></i>
        {{ 'unitsCard.featured' | translate }}
      </span>
      }

      @if (isManaged) {
      <span
        class="inline-flex w-fit items-center gap-1 rounded-lg bg-amber-500/90 px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-wider text-white backdrop-blur-sm">
        <i class="fa-solid fa-shield-halved text-[9px]"></i>
        {{ 'unitsCard.managed' | translate }}
      </span>
      }

      @if (verified) {
      <span
        class="inline-flex w-fit items-center gap-1 rounded-lg bg-emerald-600/90 px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-wider text-white backdrop-blur-sm">
        <i class="fa-solid fa-circle-check text-[9px]"></i>
        {{ 'unitsCard.verified' | translate }}
      </span>
      }
    </div>

    <!-- ── Purpose badge: top-end (with gap for fav button) ── -->
    @if (purpose) {
    <div class="absolute end-[72px] top-3 z-10">
      @if (purpose === 'rent') {
      <span
        class="inline-flex items-center gap-1 rounded-lg border border border-blue-500/30 bg-blue-500/20 px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-wider text-white backdrop-blur-sm">
        <i class="fa-solid fa-key text-[9px]"></i>
        {{ 'unitsCard.forRent' | translate }}
      </span>
      }
      @else if (purpose === 'sale') {
      <span
        class="inline-flex items-center gap-1 rounded-lg border border-primary/30 bg-primary/20 px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-wider text-white backdrop-blur-sm">
        <i class="fa-solid fa-tag text-[9px]"></i>
        {{ 'unitsCard.forSale' | translate }}
      </span>
      }
      @else if (purpose === 'sale_and_rent') {
      <span
        class="inline-flex items-center gap-1 rounded-lg border border border-violet-500/30 bg-violet-500/20 px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-wider text-white backdrop-blur-sm">
        <i class="fa-solid fa-arrows-rotate text-[9px]"></i>
        {{ 'unitsCard.saleAndRent' | translate }}
      </span>
      }
    </div>
    }

    <!-- ── Favorite button: bottom-end of image ── -->
    <div class="absolute top-3 end-3 z-20" (click)="$event.stopPropagation()">
      <app-add-to-fav [itemId]="propertyId" [initialFavorite]="isFavorite"></app-add-to-fav>
    </div>

  </div>
  <!-- / IMAGE -->

  <!-- ══════════════ BODY ══════════════ -->
  <div class="relative z-[1] flex flex-1 flex-col px-5 pb-5 pt-[18px]">

    <!-- Type row + furnished -->
    <div class="mb-2 flex items-center justify-between gap-2">
      <span
        class="text-[10.5px] font-extrabold uppercase tracking-widest text-white/60 transition-colors duration-300 group-hover:text-primary">
        {{ propertyType }}
      </span>
      @if (furnished) {
      <span
        class="inline-flex items-center gap-1 rounded-md border border-primary/20 bg-primary/10 px-2 py-0.5 text-[9.5px] font-bold text-primary">
        <i class="fa-solid fa-couch text-[9px]"></i>
        {{ 'unitsCard.furnished' | translate }}
      </span>
      }
    </div>

    <!-- Title -->
    <h3
      class="mb-2 line-clamp-2 h-[44px] text-[15px] font-bold leading-snug text-white/95 drop-shadow-[0_1px_2px_rgba(0,0,0,0.8)] transition-colors duration-300 group-hover:text-primary">
      {{ title }}
    </h3>

    <!-- Location -->
    <div class="flex items-center gap-1.5 text-xs text-white/60">
      <i class="fa-solid fa-location-dot flex-shrink-0 text-[11px] text-primary"></i>
      <span class="truncate">{{ location }}</span>
    </div>

    <!-- Divider with gradient -->
    <div class="my-3.5 h-px bg-gradient-to-r from-primary/20 to-transparent"></div>

    <!-- Specs chips -->
    <div class="flex flex-wrap gap-1.5">

      @if (bedrooms > 0) {
      <div
        class="inline-flex items-center gap-1.5 rounded-lg bg-black/40 border border-white/10 shadow-[inset_0_2px_4px_rgba(0,0,0,0.5)] px-2.5 py-1 text-xs font-semibold text-white/80">
        <i class="fa-solid fa-bed text-[11px] text-primary"></i>
        <span>{{ bedrooms }}<span class="text-[10.5px] font-normal text-white/40"> {{ 'unitsCard.beds' | translate
            }}</span></span>
      </div>
      }

      @if (bathrooms > 0) {
      <div
        class="inline-flex items-center gap-1.5 rounded-lg bg-black/40 border border-white/10 shadow-[inset_0_2px_4px_rgba(0,0,0,0.5)] px-2.5 py-1 text-xs font-semibold text-white/80">
        <i class="fa-solid fa-bath text-[11px] text-primary"></i>
        <span>{{ bathrooms }}<span class="text-[10.5px] font-normal text-white/40"> {{ 'unitsCard.baths' | translate
            }}</span></span>
      </div>
      }

      @if (area) {
      <div
        class="inline-flex items-center gap-1.5 rounded-lg bg-black/40 border border-white/10 shadow-[inset_0_2px_4px_rgba(0,0,0,0.5)] px-2.5 py-1 text-xs font-semibold text-white/80">
        <i class="fa-solid fa-ruler-combined text-[11px] text-primary"></i>
        <span>{{ area }}</span>
      </div>
      }

      @if (floorsCount > 0) {
      <div
        class="inline-flex items-center gap-1.5 rounded-lg bg-black/40 border border-white/10 shadow-[inset_0_2px_4px_rgba(0,0,0,0.5)] px-2.5 py-1 text-xs font-semibold text-white/80">
        <i class="fa-solid fa-building text-[11px] text-primary"></i>
        <span>{{ floorsCount }}<span class="text-[10.5px] font-normal text-white/40"> {{ 'unitsCard.floors' | translate
            }}</span></span>
      </div>
      }

    </div>

    <!-- ══ FOOTER: Price + Rating ══ -->
    <div class="mt-auto flex items-end justify-between border-t border-white/10 pt-3.5">

      @if (price && price !== 'undefined') {
      <div class="flex flex-col gap-0.5">
        <div class="flex items-baseline gap-1">
          <span
            class="text-[22px] font-black tracking-tight text-white/95 drop-shadow-[0_1px_2px_rgba(0,0,0,0.8)] transition-colors duration-300 group-hover:text-primary">
            {{ priceAmount }}
          </span>
          <span class="text-xs font-bold text-primary">{{ currency }}</span>
        </div>
        <span class="text-[10px] font-semibold uppercase tracking-wide text-white/40">
          @if (priceType === 'monthly') { / {{ 'unitsCard.monthly' | translate }} }
          @else if (priceType === 'daily') { / {{ 'unitsCard.daily' | translate }} }
          @else if (priceType === 'total') { {{ 'unitsCard.totalPrice' | translate }} }
        </span>
      </div>
      } @else {
      <span class="text-sm text-white/30">—</span>
      }

      @if (rating !== undefined && rating > 0) {
      <div
        class="mb-0.5 inline-flex flex-shrink-0 items-center gap-1 rounded-lg border border-primary/20 bg-primary/10 px-2.5 py-1 text-xs font-bold text-primary">
        <i class="fa-solid fa-star text-[10px]"></i>
        <span>{{ rating | number:'1.1-1' }}</span>
      </div>
      }

    </div>
    <!-- / FOOTER -->

  </div>
  <!-- / BODY -->

</div>

}
